"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_dnd_1 = require("react-dnd");
const react_dnd_html5_backend_1 = require("react-dnd-html5-backend");
const styled_components_1 = __importDefault(require("styled-components"));
const index_1 = __importDefault(require("../title/index"));
const button_1 = __importStar(require("@app/routes/SpeechDevelopment/button"));
const useWindowWidrh_1 = __importDefault(require("@hooks/useWindowWidrh"));
const smallHeader_1 = __importDefault(require("@components/smallHeader"));
const useCoins_1 = __importDefault(require("@hooks/useCoins"));
const audioPlayer_1 = require("@app/services/audioPlayer");
const audioPathNames_1 = require("@app/enums/audioPathNames");
const helpers_1 = require("@app/helpers");
const uiConfigs_1 = require("@app/constants/uiConfigs");
const exercise_1 = require("@app/components/container/exercise");
const Pagination_1 = require("@components/Pagination");
const quantityGame_1 = __importDefault(require("@components/quantity/quantityGame"));
const menuBarExercise_1 = __importDefault(require("@components/menuBar/menuBarExercise"));
const DropContainerWrapper = styled_components_1.default.div `
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    gap: 20px;
    align-items: self-start;
    justify-content: end;
    height: 100%;
    @media (max-width: 1200px) {
        justify-content: center;
    }
    @media (max-width: 700px) {
        flex-wrap: wrap-reverse;

    }
`;
const DropWrapper = styled_components_1.default.div `
    width: 80%;
    gap: 10px;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    height: 100%;
`;
const WordsWrapper = styled_components_1.default.div `
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    border: 1px dashed #6E76FB;
    min-height: 200px;
    background-color: #f5f5f5;
    border-radius: 25px;
    padding: 30px 20px;
`;
const WordItem = styled_components_1.default.div `
    background: transparent;
    padding: 5px 20px;
    border: 1px dashed #6E76FB;
    border-radius: 25px;
    cursor: pointer;
    user-select: none;
    font-size: 40px;
    font-weight: 700;
    color: #6E76FB; 
    line-height: 21px;
    font-family: Phenomena;
    transition: background-color 0.2s ease-in-out;

    ${(props) => props.isCorrect !== undefined && `
        border: ${props.isCorrect ? '1px dashed #3CB949' : '1px dashed #FE2B45'};
        color: ${props.isCorrect ? '#3CB949' : '#FE2B45'};
    `}
    &:hover {
        background-color: #dcdcdc;
    }
`;
const ImagesWrapper = styled_components_1.default.div `
    display: flex;
    flex-direction: column;
    max-width: 130px;
    gap: 20px;
    align-items: center;
    justify-content: center;
`;
const Description = styled_components_1.default.div `
    font-size: 30px;
    font-weight: bold;
    color: white;
    text-align: center;
    @media (max-width: 850px) {
        font-size: 18px;
        padding: 4px 15px;
    }

    @media (max-width: 540px) {
        font-size: 18px;
        padding: 3px 10px;
        font-weight: 700;
    }
`;
const DraggableWord = ({ wordObj, index, moveWord, zone, isHovering }) => {
    const [{ isDragging }, drag] = (0, react_dnd_1.useDrag)(() => ({
        type: 'word',
        item: Object.assign(Object.assign({}, wordObj), { index, zone }),
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    }));
    return (react_1.default.createElement(WordItem, { ref: drag, isCorrect: zone === 'sentence' ? wordObj === null || wordObj === void 0 ? void 0 : wordObj.isCorrect : undefined, style: {
            opacity: isDragging ? 0.5 : 1,
            backgroundColor: isHovering ? '#e0e0e0' : 'transparent', // Highlight on hover
        } }, wordObj.content));
};
const DropZone = ({ items, moveWord, zone }) => {
    const dropRef = (0, react_1.useRef)(null);
    const [hoveredIndex, setHoveredIndex] = (0, react_1.useState)(null); // Track the hovered index
    const [{ isOver }, drop] = (0, react_dnd_1.useDrop)(() => ({
        accept: 'word',
        hover: (draggedWord, monitor) => {
            var _a;
            if (!dropRef.current)
                return;
            const hoverBoundingRect = dropRef.current.getBoundingClientRect();
            const hoverClientY = (_a = monitor.getClientOffset()) === null || _a === void 0 ? void 0 : _a.y;
            if (hoverClientY && hoverBoundingRect) {
                const hoverIndex = Math.floor((hoverClientY - hoverBoundingRect.top) / (hoverBoundingRect.height / items.length));
                setHoveredIndex(hoverIndex);
                if (hoverIndex >= 0 && hoverIndex < items.length) {
                    moveWord(draggedWord, zone, hoverIndex);
                }
            }
        },
        drop: (draggedWord) => {
            moveWord(draggedWord, zone, hoveredIndex !== null ? hoveredIndex : -1);
            setHoveredIndex(null); // Reset hovered index after drop
        },
        collect: (monitor) => ({
            isOver: monitor.isOver(),
        }),
    }), [moveWord, zone, hoveredIndex]);
    (0, react_1.useLayoutEffect)(() => {
        if (dropRef.current) {
            drop(dropRef);
        }
    }, [drop]);
    return (react_1.default.createElement(WordsWrapper, { ref: dropRef }, (items || []).map((wordObj, index) => (react_1.default.createElement(DraggableWord, { key: wordObj.id, wordObj: wordObj, index: index, moveWord: moveWord, zone: zone, isHovering: hoveredIndex === index, onHover: () => setHoveredIndex(index), onLeave: () => setHoveredIndex(null) })))));
};
const PhraseBuilder = ({ response, description, langId }) => {
    const [initialWords, setInitialWords] = (0, react_1.useState)([]);
    const [words, setWords] = (0, react_1.useState)([]);
    const [sentence, setSentence] = (0, react_1.useState)([]);
    const [title, setTitle] = (0, react_1.useState)('');
    const { coinCount, rubyCount, diamondCount, addCoin } = (0, useCoins_1.default)();
    const getLabel = () => {
        if (+langId === 1) {
            return "Проверить";
        }
        return "Check";
    };
    const [checkButtons, setCheckButtons] = (0, react_1.useState)(uiConfigs_1.initialButtonState);
    const windowWidth = (0, useWindowWidrh_1.default)();
    const handleAddCoin = () => {
        addCoin(3, 5);
    };
    (0, react_1.useEffect)(() => {
        var _a, _b, _c;
        if (response) {
            setTitle((_a = response === null || response === void 0 ? void 0 : response.text) === null || _a === void 0 ? void 0 : _a.title);
            setWords((0, helpers_1.shuffleArray)((_b = response === null || response === void 0 ? void 0 : response.text) === null || _b === void 0 ? void 0 : _b.offers));
            setInitialWords((_c = response === null || response === void 0 ? void 0 : response.text) === null || _c === void 0 ? void 0 : _c.offers.sort((a, b) => a.order - b.order));
        }
    }, [response]);
    const moveWord = (draggedWord, toZone, hoverIndex = -1) => {
        if (toZone === 'sentence') {
            setSentence((prevSentence) => {
                const filtered = prevSentence.filter((word) => word.id !== draggedWord.id);
                if (hoverIndex >= 0 && hoverIndex <= filtered.length) {
                    return [...filtered.slice(0, hoverIndex), draggedWord, ...filtered.slice(hoverIndex)];
                }
                else {
                    return [...filtered, draggedWord];
                }
            });
            setWords((prevWords) => prevWords.filter((word) => word.id !== draggedWord.id));
        }
        else if (toZone === 'words') {
            setWords((prevWords) => {
                const filtered = prevWords.filter((word) => word.id !== draggedWord.id);
                if (hoverIndex >= 0 && hoverIndex <= filtered.length) {
                    return [...filtered.slice(0, hoverIndex), draggedWord, ...filtered.slice(hoverIndex)];
                }
                else {
                    return [...filtered, draggedWord];
                }
            });
            setSentence((prevSentence) => prevSentence.filter((word) => word.id !== draggedWord.id));
        }
    };
    const checkSentence = () => {
        if ((initialWords === null || initialWords === void 0 ? void 0 : initialWords.length) !== (sentence === null || sentence === void 0 ? void 0 : sentence.length)) {
            audioPlayer_1.audioPlayer.playAudio('x', +langId === 1 ? 'https://d9fvxjfzq4088.cloudfront.net/sound_errors/Russian-error-318.mp3' : 'https://d9fvxjfzq4088.cloudfront.net/sound_errors/English-error-318.mp3');
            return false;
        }
        const updatedSentence = sentence === null || sentence === void 0 ? void 0 : sentence.map((word, index) => {
            if (initialWords[index].order === word.order) {
                return Object.assign(Object.assign({}, word), { isCorrect: true });
            }
            else {
                return Object.assign(Object.assign({}, word), { isCorrect: false });
            }
        });
        setSentence(updatedSentence);
        const checkedResul = initialWords.every((item, index) => item.order === sentence[index].order);
        if (checkedResul) {
            handleAddCoin();
            // @ts-ignore
            window.stopExercise(true, true, response === null || response === void 0 ? void 0 : response.id);
        }
        else {
            audioPlayer_1.audioPlayer.playAudio(+langId === 1 ? audioPathNames_1.AudioPathNames.Incorrect : audioPathNames_1.AudioPathNames.Incorrect_en);
        }
        return initialWords.every((item, index) => item.order === sentence[index].order);
    };
    const handleCheckButtonClick = () => {
        setCheckButtons((prevButtons) => {
            const indexToUpdate = prevButtons.findIndex(button => !button.isChecked);
            if (indexToUpdate === -1) {
                // @ts-ignore
                window.stopExercise(true, true, response === null || response === void 0 ? void 0 : response.id);
                return prevButtons;
            }
            return prevButtons.map((button, index) => {
                if (index === indexToUpdate) {
                    if (indexToUpdate === (checkButtons === null || checkButtons === void 0 ? void 0 : checkButtons.length) - 1) {
                        // @ts-ignore
                        window.stopExercise(true, true, response === null || response === void 0 ? void 0 : response.id);
                    }
                    return Object.assign(Object.assign({}, button), { isChecked: true, isCorrect: checkSentence() });
                }
                return button;
            });
        });
    };
    return (react_1.default.createElement(react_dnd_1.DndProvider, { backend: react_dnd_html5_backend_1.HTML5Backend },
        windowWidth <= 1200 ? react_1.default.createElement(smallHeader_1.default, { exerciseName: "\u0421\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0444\u0440\u0430\u0437 \u0438 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0439" }) : react_1.default.createElement(react_1.default.Fragment, null),
        react_1.default.createElement(exercise_1.ContainerExercise, null,
            windowWidth <= 1200 ? react_1.default.createElement(react_1.default.Fragment, null) :
                react_1.default.createElement(index_1.default, { text: "\u0421\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0444\u0440\u0430\u0437 \u0438 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0439" }),
            react_1.default.createElement(exercise_1.ExerciseWrapper, null,
                react_1.default.createElement(Description, null, description || ''),
                react_1.default.createElement(DropContainerWrapper, null,
                    react_1.default.createElement(DropWrapper, null,
                        react_1.default.createElement(DropZone, { items: sentence, moveWord: moveWord, zone: "sentence" }),
                        react_1.default.createElement(DropZone, { items: words, moveWord: moveWord, zone: "words" })),
                    react_1.default.createElement(quantityGame_1.default, { diamondCount: diamondCount, rubyCount: rubyCount, goldCoin: coinCount })),
                react_1.default.createElement(Pagination_1.Pagination, null, checkButtons.map((item, index) => react_1.default.createElement(Pagination_1.PaginationItem, { key: index, item: item, active: item.isCorrect && item.isChecked ? "linear-gradient(130deg, #6cff4f 13.21%, #13c21c 81.73%)" : !item.isCorrect && item.isChecked ? "#FF1431" : null })))),
            react_1.default.createElement(menuBarExercise_1.default, null,
                react_1.default.createElement(button_1.ButtonContainerWrapper, null,
                    react_1.default.createElement(button_1.default, { isShowShadow: false, label: getLabel(), onClick: handleCheckButtonClick, isCheckButton: true }))))));
};
exports.default = PhraseBuilder;
